<template>
    <v-container>
        <Loading :value="loading" ></Loading>
        <el-form ref="formAbsence"  :model="formDmdAbsence" class="demo-form-inline">
            <el-row type="flex" :gutter="20" justify="center">
                <el-col :span="14">
                    <div class="block">
                        <el-form-item label="Période de congé">
                            <el-date-picker
                              style="width: 100%"
                              v-model="formDmdAbsence.datedbtFin"
                              format="dd-MM-yyyy HH:mm"
                              value-format="yyyy-MM-dd HH:mm"
                              type="datetimerange"
                              range-separator="au"
                              start-placeholder="Début date"
                              end-placeholder="Fin date"
                            ></el-date-picker>
                        </el-form-item>
                     </div>
                </el-col>
                <el-col :span="10">
                    <div>
                        <el-form-item label="Type de congé">
                            <el-select v-model="formDmdAbsence.idTypeConge" placeholder="Type de congé">
                                <el-option v-for="(item,index) in listeTypeConge" :key=index :label="item.label" :value="item.value" ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center">
                <el-col :span="24">

                        <el-form-item style="width:97%" label="Description">
                            <el-input type="textarea" :rows="6" v-model="formDmdAbsence.desc"></el-input>
                        </el-form-item>

                </el-col>
            </el-row>

            <el-row type="flex" :gutter="20" >
                <el-col :span="24" >
                    <el-upload class="upload-demo"
                               list-type="picture-card"
                               name="photo" action=""
                               ref="uploadFichAbsence"
                               :auto-upload="false"
                               :on-change = "changeFile"
                               :multiple="true"  >
                        <img height="142" width="142" src="" class="lazy" alt="">
                    </el-upload>
                </el-col>
            </el-row>

            <el-row type="flex" :gutter="20"  justify="end">
                <el-col :span="6" >
                    <div style="width:100%" class="mt-4">
                        <v-tooltip top>
                            <v-btn
                                    :disabled="!formIsValid"
                                    slot="activator"
                                    class="white--text"
                                    color="green"
                                    @click="submitForm()"
                            >

                                Enregistrer
                                <v-icon right>save</v-icon>
                            </v-btn>
                            enregistrer une demande
                        </v-tooltip>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </v-container>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        components: {Loading},
        name: "formAbsence",
        props:{
            nbJrsRestantVacance: {
                type: Number,
                default: 0
            }
        },
        data(){
            return{
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,

                formDmdAbsence:{},
                listeTypeConge:[],
                listePhotos:[],

            }
        },
        methods:{
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },

            submitForm(){
                this.loading = true;
                let url = this.domaine + 'rh/absence/'+this.user.id
                let data = new FormData();
                data.append("dataForm", JSON.stringify(this.formDmdAbsence))


                if (this.listePhotos.length > 0) {
                    this.listePhotos.forEach(file => {
                        data.append("fichierImage[]", file, file[name]);
                    }, this);
                }

                this.$http.post(url,data).then(response => {
                        this.loading = false
                        if(response.body.code == 0){
                            this.$alert(response.body.message, "Demande d'absence", {
                                confirmButtonText: 'OK',
                            });
                            return;
                        }
                          this.formDmdAbsence.datedbtFin = ''
                          this.formDmdAbsence.idTypeConge = ''
                          this.formDmdAbsence.desc = ''

                        this.resetForm('formAbsence')
                        this.closeForm();

                        this.successNotif(response.body.message)
                        this.listePhotos.splice(0)
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors de l'enregistrement de la demande")
                    })
            },

            loadTypeConge(){
                let url = this.domaine + 'rh/listeTypeConge';
                this.$http.get(url).then(resData => {
                        this.listeTypeConge = resData.body.listeAbsences;

                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors du chargement de al liste des type de congé")
                    })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

            closeForm(){
                this.$emit("close");
            },

            changeFile(file,fileList){
                this.listePhotos.splice(0);
                const fileReader = new FileReader()

                for (const ind in fileList){
                    let filename = fileList[ind].name;
                    if( filename.lastIndexOf(".") <= 0 ){
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    //fileReader.readAsDataURL(fileList[ind].raw)
                    this.listePhotos.push(fileList[ind].raw);
                }


                // fileReader.addEventListener("load", () => {
                //     this.listePhotos = fileReader.result
                // })


            },
        },
        computed:{
            formIsValid(){

                if(this.formDmdAbsence.datedbtFin == null || this.formDmdAbsence.idTypeConge == null  || (this.formDmdAbsence.desc == "" || this.formDmdAbsence.desc == undefined ) ) {
                    return false;
                }
                else {
                    return true;
                }
            }
        },
        mounted(){
            this.loadTypeConge()
        }
    }
</script>

<style scoped>
    .el-form-item__content {
        width: 70%;
    }
</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/form_absence.vue